import apiClient from '../service/api'

// GET All voices
export const getAllVoices = async (page) => {
  const { data } = await apiClient.get('/v1/resources/voices', {
    params: { page },
  })
  return data
}

// Get All Aivatars
export const getAllAivatars = async (page) => {
  const { data } = await apiClient.get('/v1/resources/aivatars', {
    params: { page },
  })
  return data
}

// Get Acting Videos
export const getActingVideos = async (page) => {
  const { data } = await apiClient.get('/v1/resources/actingvideos', {
    params: { page },
  })
  return data
}

// Get Acting Video
export const getActingVideo = async (videoId) => {
  const { data } = await apiClient.get(`/v1/resources/actingvideos/${videoId}`)
  return data
}

// Get Deep running Models
export const getModels = async (page) => {
  const { data } = await apiClient.get('/v1/resources/models', {
    params: { page },
  })
  return data
}

// Get Deep running Model
export const getModel = async (modelId) => {
  const { data } = await apiClient.get(`/v1/resources/models/${modelId}`)
  return data
}
